"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesktopDrawer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const useMeasure_1 = __importDefault(require("react-use/lib/useMeasure"));
const useWindowSize_1 = __importDefault(require("react-use/lib/useWindowSize"));
const useDrawer_1 = require("../../../hooks/useDrawer/useDrawer");
const useLocale_1 = require("../../../hooks/useLocale/useLocale");
const DrawerArrowIcon_1 = require("../../../assets/icons/DrawerArrowIcon");
const ProfileIcon_1 = require("../../../assets/icons/ProfileIcon");
const DrawerListItem_1 = require("../drawerListItem/DrawerListItem");
const TextEllipsisWithTooltip_1 = require("../../textEllipsis/TextEllipsisWithTooltip");
const messages_1 = require("../../../core/i18n/messages");
const DrawerListItem_styles_1 = require("../drawerListItem/DrawerListItem.styles");
const DrawerListItemMore_1 = require("../drawerListItemMore/DrawerListItemMore");
const RootStyled = __importStar(require("../DrawerLayout.styles"));
const Styled = __importStar(require("./DesktopDrawer.styles"));
const MAX_USERNAME_WIDTH = 170;
const DesktopDrawer = ({ drawerRoutes, logo, profileRoute, onClickRoute }) => {
    const { isDrawerOpen, setIsDrawerOpen } = (0, useDrawer_1.useDrawer)();
    const { formatMessage } = (0, useLocale_1.useLocale)();
    const profileRouteCount = profileRoute ? 1 : 0;
    const moreButtonCount = 1;
    const { height: windowHeight } = (0, useWindowSize_1.default)();
    const [logoRef, { height: logoHeight }] = (0, useMeasure_1.default)();
    const visibleRoutes = drawerRoutes.filter((route) => route.isVisible);
    const fullLogoHeight = logoHeight + Styled.LOGO_MARGIN_TOP;
    const availableHeight = windowHeight -
        fullLogoHeight -
        Styled.DRAWER_LIST_MARGIN_BOTTOM -
        Styled.DRAWER_LIST_MARGIN_TOP -
        DrawerListItem_styles_1.DRAWER_LIST_ITEM_MARGIN_BOTTOM * (visibleRoutes.length + profileRouteCount);
    const visibleItemsCount = Math.floor(availableHeight / DrawerListItem_styles_1.DRAWER_LIST_ITEM_HEIGHT) - profileRouteCount - moreButtonCount;
    const adjustedVisibleItemsCount = visibleRoutes.length - visibleItemsCount === 1 ? visibleItemsCount + 1 : visibleItemsCount;
    const mainRoutes = visibleRoutes.slice(0, adjustedVisibleItemsCount);
    const hiddenRoutes = visibleRoutes.slice(adjustedVisibleItemsCount);
    return ((0, jsx_runtime_1.jsxs)(Styled.Drawer, { "$isDrawerOpen": isDrawerOpen, variant: "permanent", children: [(0, jsx_runtime_1.jsx)(Styled.OpenDrawerIcon, { "$isDrawerOpen": isDrawerOpen, onClick: () => setIsDrawerOpen(!isDrawerOpen), children: (0, jsx_runtime_1.jsx)(DrawerArrowIcon_1.DrawerArrowIcon, { isDrawerOpen: isDrawerOpen }) }), (0, jsx_runtime_1.jsx)(Styled.LogoContainer, { ref: logoRef, "$isDrawerOpen": isDrawerOpen, children: logo }), (0, jsx_runtime_1.jsxs)(Styled.List, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [!!mainRoutes.length &&
                                mainRoutes.map((route) => ((0, jsx_runtime_1.jsx)(DrawerListItem_1.DrawerListItem, { icon: route.icon, activeIcon: route.activeIcon, to: route.to, title: route.title, open: isDrawerOpen, onClickRoute: onClickRoute }, route.to))), !!hiddenRoutes.length && ((0, jsx_runtime_1.jsx)(DrawerListItemMore_1.DrawerListItemMore, { routes: hiddenRoutes, title: formatMessage({ id: messages_1.AppMessages['common.different'] }), open: isDrawerOpen, onClickRoute: onClickRoute }))] }), profileRoute && ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(DrawerListItem_1.DrawerListItem, { icon: (0, jsx_runtime_1.jsx)(RootStyled.ProfileIconCircle, { children: (0, jsx_runtime_1.jsx)(ProfileIcon_1.ProfileIcon, {}) }), to: profileRoute.to, title: (0, jsx_runtime_1.jsx)(TextEllipsisWithTooltip_1.TextElipsisWithTooltip, { text: profileRoute.title, width: MAX_USERNAME_WIDTH }), open: isDrawerOpen, onClickRoute: onClickRoute, noHighlight: true }) }))] })] }));
};
exports.DesktopDrawer = DesktopDrawer;
